export default class SalaryService {
  constructor (http, store, router) {
    this.$http = http
    this.$store = store
    this.$router = router
  }

  getSalaries () {
    return new Promise((resolve, reject) => {
      this.$http.get('salaries')
        .then(res => res.data)
        .then(data => {
          resolve(data.data)
        })
        .catch(reject)
    })
  }

  createSalary (data) {
    return new Promise((resolve, reject) => {
      this.$http.post('salaries/create', data)
        .then(res => res.data)
        .then(data => {
          if (data.status === 'error') reject(new Error(data.message))
          resolve(data.data)
        })
        .catch(reject)
    })
  }
}
